import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/central-settings/central-setting-event.js